export default __webpack_public_path__ + "static/media/btc_ai_icon.287d3505.svg";